export default function Button({ children, variant = "primary", className = "", ...props }) {
    const baseStyle = "rounded-full font-bold px-8 py-3 hover:scale-105 transition-all duration-300";
    const variants = {
        primary: "bg-gradient-to-r from-[#00f2ff] to-[#7000ff] text-white shadow-[0_0_20px_rgba(0,242,255,0.4)] hover:shadow-[0_0_30px_rgba(112,0,255,0.6)]",
        secondary: "border-2 border-[#00f2ff] text-[#00f2ff] bg-transparent hover:bg-[#00f2ff]/10 hover:shadow-[0_0_15px_rgba(0,242,255,0.2)]"
    };
    return (
        <button className={`${baseStyle} ${variants[variant]} ${className}`} {...props}>
            {children}
        </button>
    );
}